import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import IconMagnify from 'components/icons/IconMagnify';
import { colorGrayLight2, colorWhite } from 'styles/layout/colors';

const PDPMobileGalleryZoomIcon = ({ onClick, inverted = false, variant }) => (
  <button
    type="button"
    className={classNames(
      'items-center border-0 rounded-[40px] text-white flex justify-center',
      {
        'bg-grayOverlay': !inverted,
        'bg-white border border-solid border-gray-light7': inverted,
        'h-10 w-10': variant !== 'ModularItem',
        'absolute right-[5px] top-[5px] !bg-transparent w-[15px] h-[15px] [&_svg_path]:!fill-gray':
          variant === 'ModularItem',
      }
    )}
    onClick={onClick}
  >
    <IconMagnify
      width={16}
      height={16}
      color={inverted ? colorGrayLight2 : colorWhite}
    />
  </button>
);

PDPMobileGalleryZoomIcon.propTypes = {
  inverted: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['ModularItem']),
};

export default PDPMobileGalleryZoomIcon;
